import { BaseChartAPI } from '../base-chart/base-chart-api.js';
class AxisChartAPI extends BaseChartAPI {
    /**
     * Returns the chart brush properties.
     */
    getBrush() {
        return this.state.brush;
    }
    /**
     * Sets the brush properties.
     *
     * @param brush - The brush properties.
     */
    setBrush(brush) {
        this.setState({ ...this.state, brush });
    }
    /**
     * Returns the chart layout.
     */
    getLayout() {
        return this.state.layout;
    }
    /**
     * Sets the chart layout.
     *
     * @param layout - The new layout.
     */
    setLayout(layout) {
        this.setState({ ...this.state, layout });
    }
    /**
     * Returns is the brush is visible.
     */
    getShowBrush() {
        return this.state.showBrush;
    }
    /**
     * Sets if the brush should be visible.
     *
     * @param showBrush - If the brush should be visible.
     */
    setShowBrush(showBrush) {
        this.setState({ ...this.state, showBrush });
    }
    /**
     * Returns the sync id.
     */
    getSyncId() {
        return this.state.syncId;
    }
    /**
     * Sets the sync id.
     *
     * @param syncId - The new sync id.
     */
    setSyncId(syncId) {
        this.setState({ ...this.state, syncId });
    }
    /**
     * Returns the X axis properties.
     */
    getXAxis() {
        return this.state.xAxis;
    }
    /**
     * Sets the X axis properties.
     *
     * @param xAxis - the X axis properties.
     */
    setXAxis(xAxis) {
        this.setState({ ...this.state, xAxis });
    }
    /**
     * Returns the X axis properties.
     */
    getYAxis() {
        return this.state.yAxis;
    }
    /**
     * Sets the Y axis properties.
     *
     * @param yAxis - the Y axis properties.
     */
    setYAxis(yAxis) {
        this.setState({ ...this.state, yAxis });
    }
}
export { AxisChartAPI, };
//# sourceMappingURL=axis-chart-api.js.map